// extracted by mini-css-extract-plugin
module.exports = {"fontControls":"FontStyleControls_fontControls__14A0C","fontControlsSingleSelect":"FontStyleControls_fontControlsSingleSelect__LVAwl"};